import { authorization } from "../endpoints";
import axios from "axios";

export const authorize = async (token: any) => {
  // const config = {
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${token}`
  //   },
  // };
  try {
    const caller = localStorage.getItem('loginCaller')||sessionStorage.getItem('loginCaller');
    
    const resp = await axios.get(`${authorization}?loggedInUserType=${caller}`, {
      method: 'get',
      headers: {
        'x-api-key':"gmedocumenthubtest.castrol.com",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    })
    // const resp = await axios.get('http://localhost:3000/mock/auth_token.json');
    return resp.data;
    //return "User is not authorized to access this resource with an explicit deny"
  }
  catch (ex) {
    throw ex;
  }
};
